import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Image from '../../components/Image';

function EventBanner({ banner }) {
  return (
    <Box
      sx={{
        height: '274px',
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '-10%',
          left: '-10%',
          height: '120%',
          width: '120%',
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${banner})`,
          filter: 'blur(15px)',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      ></Box>
      <Box
        sx={{
          'position': 'absolute',
          'width': '100%',
          'height': '250px',
          'display': 'flex',
          'justifyContent': 'center',
          'alignItems': 'center',
          '& img': {
            height: '200px',
          },
        }}
      >
        <Image src={banner} />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '24px',
          bottom: '0',
          backgroundColor: '#FFF',
          borderTopLeftRadius: '24px',
          borderTopRightRadius: '24px',
        }}
      ></Box>
    </Box>
  );
}

EventBanner.propTypes = {
  banner: PropTypes.any.isRequired,
};

export default EventBanner;
